import { type ActiveOffersResponse, type BuyerOffer } from './aliases';

import { type CurrencyCode } from '@/modules/currencies/constants';
import { type DisplayPrice } from '@/modules/price/aliases';
import { type TransformedPriceEstimateDictionary } from '@/modules/price/types';

export type OfferProductPrice = {
  currencyName: CurrencyCode;
  baseOriginalPrice: string;
  baseCurrentPrice: string;
  displayPrice?: DisplayPrice;
};

export type CounterOfferProductPrice = {
  sellersLowestOffer?: string;
  offerersHighestOffer?: string;
} & OfferProductPrice;

export type OfferError = {
  code: number;
  message: string;
  action: string;
  id: string;
};

export type CreateOfferRequestBody = {
  product_id: number;
  offer_value: string;
  offer_currency: string;
  variant_id?: number;
};

export type CounterOfferRequestBody = {
  product_id: number;
  offer_value: string;
  offer_currency: string;
  variant_id?: number;
};

export const BuyerOfferDisplayStatus = {
  ACCEPTED: 'ACCEPTED',
  BINDING_COUNTER_SENT: 'BINDING_COUNTER_SENT',
  BINDING_SENT: 'BINDING_SENT',
  COUNTER_RECEIVED: 'COUNTER_RECEIVED',
  COUNTER_SENT: 'COUNTER_SENT',
  DISMISSED: 'DISMISSED',
  EXPIRED_PRIVATE_OFFER: 'EXPIRED_PRIVATE_OFFER',
  EXPIRED_RECEIVED: 'EXPIRED_RECEIVED',
  EXPIRED_SENT: 'EXPIRED_SENT',
  RECEIVED: 'RECEIVED',
  RECEIVED_PRIVATE_OFFER: 'RECEIVED_PRIVATE_OFFER',
  REDEEMED: 'REDEEMED',
  REJECTED: 'REJECTED',
  SENT: 'SENT',
  SOLD_PRIVATE_OFFER: 'SOLD_PRIVATE_OFFER',
  SOLD_RECEIVED: 'SOLD_RECEIVED',
  SOLD_SENT: 'SOLD_SENT',
} as const;

export type BuyerOfferDisplayStatus =
  (typeof BuyerOfferDisplayStatus)[keyof typeof BuyerOfferDisplayStatus];

export type Offer = Omit<BuyerOffer, 'offer_display_status'> & {
  offer_display_status: BuyerOfferDisplayStatus;
};

export type OfferResponse = Omit<ActiveOffersResponse, 'objects'> & {
  objects: Offer[];
};

export enum OfferRole {
  Buyer = 'buyer',
  Seller = 'seller',
}

export type GuestOfferPriceQuoteRequestBody = {
  product_id: number;
  offer_value: string;
};

export type GuestOfferPriceQuoteResponse = {
  pricing: TransformedPriceEstimateDictionary;
};
